module.exports = __webpack_public_path__ + "img/shouquan@2x.281dd7e5.png";